import { requestWithBody, get } from './fetch';

export const getBranches = (customerId : number) => {
  return get({ endpoint: `api/customer/${customerId}/branch`});
};

export const saveBranchItem = (customerId : number, branch : any) => {
  return requestWithBody({ endpoint: `api/customer/${customerId}/branch`, body: branch}, 'POST');
};

export const updateBranchItem = (customerId : number, branch : any) => {
  return requestWithBody({ endpoint: `api/customer/${customerId}/branch/${branch.id}`, body: branch}, 'PATCH');
};